module.exports = __webpack_public_path__ + "assets/img/banner2.4a79e198.png";